import { render } from "./KnCalculatedField.vue?vue&type=template&id=f15b3b42&ts=true"
import script from "./KnCalculatedField.vue?vue&type=script&lang=ts"
export * from "./KnCalculatedField.vue?vue&type=script&lang=ts"

import "./KnCalculatedField.vue?vue&type=style&index=0&id=f15b3b42&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__